// extracted by mini-css-extract-plugin
export default {"layout":"two-columns_layout__EAsT3"};